export const ScheduleSearchAutocompleteArrowsHandling = () => {
    return {
        arrowsSelected: undefined,
        handleAutocompleteKeyUp(event) {
            if (event.keyCode === 38) {
                event.preventDefault();
                this.autocompleteOnKeyUp();
            }
            if (event.keyCode === 40) {
                event.preventDefault();
                this.autocompleteOnKeyDown();
            }
            if (event.keyCode === 13) {
                if (this.arrowsSelected) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.selectSuggestion(this.arrowsSelected);
                }
            }
        },
        autocompleteOnKeyDown() {
            if (!this.arrowsSelected) {
                this.arrowsSelected = this.results[0];
                return;
            }
            const currentIndex = this.results.indexOf(this.arrowsSelected);
            const nextIndex = this.results[currentIndex + 1] ? currentIndex + 1 : 0;
            this.arrowsSelected = this.results[nextIndex];
        },
        autocompleteOnKeyUp() {
            if (!this.arrowsSelected) {
                return;
            }
            const currentIndex = this.results.indexOf(this.arrowsSelected);
            const nextIndex = this.results[currentIndex + -1] ? currentIndex - 1 : this.results.length - 1;
            this.arrowsSelected = this.results[nextIndex];
        },
    };
};
